import { render, staticRenderFns } from "./RegisteredProductsRequestWarranty.vue?vue&type=template&id=6d49b0a6"
import script from "./RegisteredProductsRequestWarranty.vue?vue&type=script&lang=js"
export * from "./RegisteredProductsRequestWarranty.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports